// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__HBiRE"};